import * as React from "react";
import {Column, Row} from "../../digitalarz/data-grid/TypeDeclaration";
import Api, {APIs} from "../../../Api";
import PotentialProjectGrid from "../components/PotentialProjectGrid";
import {useSelector} from "react-redux";
import {Box} from "@mui/material";


const PipelineProjects = () => {
    const params = useSelector((state: any) => state.dashboard)
    const [rows, setRows] = React.useState<Row[]>([])
    const [columns, setColumns] = React.useState<Column[]>([])
    React.useEffect(() => {
        if (rows.length === 0 && columns.length === 0) {
            Api.get(APIs.MoPD_PIPELINE_PROJECTS, {
                "sro": params.sro, "sector": params.sector,
                donor: params.donor, "region": params.region
            }).then((payload) => {
                if (payload) {
                    setRows(payload.rows)
                    setColumns(payload.columns)
                }
            });
        }
    }, [])
    return (<React.Fragment>
        <Box sx={{"width": "100%", height:"auto", p:1}}>
            <PotentialProjectGrid key={"potential-project-grid"}
                                  data={rows} columns={columns}
                                  title={"Potential Projects"}
                                  tableHeight={"auto"}
                                  tableWidth={"auto"}></PotentialProjectGrid>
        </Box>
    </React.Fragment>)
}

export default PipelineProjects
